import {cn} from "@/lib/utils.ts";
import {Search} from "lucide-react";

interface SearchBarProps {
    onChange: (value: string) => void;
    value: string;
    onFocus?: () => void;
    className?: string;
    placeholder?: string;
    id?: string;
}

export default function SearchBar({value, onChange, onFocus, className, placeholder = "Suche", id}: SearchBarProps) {

    return (<div className="relative inline-flex items-center justify-center w-full">
        <div
            className="absolute inset-y-0 inset-s-0 flex items-center ps-2 pointer-events-none">
            <Search className="size-4 text-muted-foreground"/>
        </div>
        <input id={id} type="text"
               aria-label={placeholder}
               value={value} onChange={(e) => onChange(e.target.value)}
               onFocus={onFocus}
               className={cn(
                   "block grow rounded-lg border border-input bg-surface px-2 py-1.5 ps-8 " +
                   "text-sm text-foreground shadow-inner shadow-black/10 outline-none transition-[border-color,box-shadow] " +
                   "placeholder:text-muted-foreground focus:border-ring focus:ring-3 focus:ring-ring/30",
                   className
               )}

               placeholder={placeholder}/>
        {value &&
            <button type="button" onClick={() => onChange("")}
                    className="absolute top-2 right-1 size-4 inline-flex justify-center items-center
                       cursor-pointer text-muted-foreground hover:text-foreground">
                <svg className="w-2 h-2 " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                          strokeWidth="3" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                </svg>
            </button>}
    </div>)
}
